export default "__VITE_ASSET__BglJv6Nk__"